// TODO: expand put/get to accept objects. Note that these have to be serialized to JSON before putting them into the storage

export const putLocalStorageItem = (key: string, item: string) => {
  try {
    if (!item) {
      $reportError('cant put null into local storage')
      return
    }

    localStorage.setItem(key, item)
  }
  catch (error) {
    $reportError('Error while putting item into local storage: \n' + error)
  }
}

export const getLocalStorageItem = (
  item: string,
  removeItem: boolean = false,
) => {
  // this threw an error for some reason (local storage was null?), so try/catch it is
  try {
    const value = localStorage.getItem(item)
    if (!value) {
      $log('No item found for ' + item + ' in local storage')
      return ''
    }
    // maybe do this to prevent local storage from getting too full
    // note that this will prevent the site from working as expected if refreshed
    if (removeItem) {
      localStorage.removeItem(item)
    }

    return value
  }
  catch (error) {
    $reportError('Error while taking item from local storage: \n' + error)
    return ''
  }
}

export const removeLocalStorageItem = (item: string) => {
  try {
    localStorage.removeItem(item)
  }
  catch (error) {
    $reportError('Error while removing item from local storage: \n' + error)
  }
}

export const putSessionStorageItem = (key: string, item: string) => {
  try {
    if (!item) {
      $reportError('Can\'t put null into session storage')
      return
    }

    sessionStorage.setItem(key, item)
  }
  catch (error) {
    $reportError('Error while putting item into session storage: \n' + error)
  }
}

export const getSessionStorageItem = (
  item: string,
  removeItem: boolean = false,
) => {
  try {
    const value = sessionStorage.getItem(item)
    if (!value) {
      $log('No item found for ' + item + ' in session storage')
      return ''
    }
    if (removeItem) {
      sessionStorage.removeItem(item)
    }

    return value
  }
  catch (error) {
    $reportError('Error while taking item from session storage: \n' + error)
    return ''
  }
}

export const removeSessionStorageItem = (item: string) => {
  try {
    sessionStorage.removeItem(item)
  }
  catch (error) {
    $reportError('Error while removing item from session storage: \n' + error)
  }
}
